import axios from "axios";

export async function adduserContact(payload) {
    let { data } = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}contactUs/add`,
        payload,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
    // let { data } = await axios.get(
    //     `${process.env.REACT_APP_API_ENDPOINT}contactUs/list`,
    //     {
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //     }
    // );

    return data;
}

